module.exports = __webpack_public_path__ + "img/box9-17.6480519e.png";